import { useUnit } from 'effector-react'

import { $currentCreator } from '@/models/creators.ts'
import { FanNumberingForm } from '@/modules/automations/ui/forms/fan-numbering-form'
import { SettingsSkeleton } from '@/modules/automations/ui/skeleton'
import { useSettingsContext } from '@/modules/creator-settings/state/SettingsProvider'

export const FanNumberingView = () => {
  const { isFetching } = useSettingsContext()
  const activeCreator = useUnit($currentCreator)

  if (isFetching || !activeCreator) {
    return <SettingsSkeleton />
  }

  return <FanNumberingForm />
}
